var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { CloseRounded, ContentCopyRounded, DeleteRounded, SaveRounded, VisibilityRounded, } from "@mui/icons-material";
import { Grid, styled, Typography, Box, Tooltip } from "@mui/material";
import { useState, useEffect } from "react";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import VTButton from "../components/VTButton";
import textCutOffAddElipsis from "../utils/textCutOffAddElipsis";
import VTMenu from "./VTMenu";
import VTTextField from "./VTTextField";
import { EMedia } from "../models/media.model";
import VTLocation from "./VTLocation";
export var TimelineImageWrapper = styled(Grid)(function (_a) {
    var theme = _a.theme;
    return ({
        borderRadius: "15px",
        height: "100px",
        overflow: "hidden",
        position: "relative",
        transition: ".5s",
        ":hover": {
            cursor: "pointer",
            boxShadow: "0 0 25px #2ad5c7",
        },
    });
});
export var MediaType;
(function (MediaType) {
    MediaType[MediaType["VIDEO"] = 0] = "VIDEO";
    MediaType[MediaType["PICTURE"] = 1] = "PICTURE";
})(MediaType || (MediaType = {}));
//Now use a useState to change the colour of the border radius (from grey to lime green).
//Ask whether the option menu should have any actions (drop down menu)
function getMediaTypeImageStyleObject(size) {
    return size > 115 ? { height: "50px", width: "50px" } : { height: "25px", width: "25px" };
}
export default function VTTimelineImageItem(_a) {
    var titleCutOffLimit = _a.titleCutOffLimit, sx = _a.sx, active = _a.active, _b = _a.size, size = _b === void 0 ? 150 : _b, currentScene = _a.currentScene, setSceneName = _a.setSceneName, setSceneDuplicate = _a.setSceneDuplicate, setSceneDelete = _a.setSceneDelete, setSceneInitialView = _a.setSceneInitialView, _c = _a.onClicked, onClicked = _c === void 0 ? function () { return console.log("scene clicked"); } : _c, _d = _a.menuOffSet, menuOffSet = _d === void 0 ? { height: 270, width: 120 } : _d;
    var _e = __read(useState(false), 2), isHovered = _e[0], setIsHovered = _e[1];
    var _f = __read(useState(false), 2), initialViewDialog = _f[0], setInitialViewDialog = _f[1];
    var id = currentScene.id, name = currentScene.name, previewImage = currentScene.previewImage, mediaType = currentScene.mediaType, src = currentScene.src;
    var _g = __read(useState(name), 2), localSceneName = _g[0], setLocalSceneName = _g[1];
    var _h = __read(useState(false), 2), menuOpen = _h[0], setMenuOpen = _h[1];
    useEffect(function () {
        setLocalSceneName(name);
    }, [name]);
    // linear-gradient(to bottom, #0ab5a7,#8e25fa)
    return (_jsxs(_Fragment, { children: [_jsxs(Grid, __assign({ container: true, sx: __assign(__assign({ width: size }, sx), { position: "relative" }) }, { children: [_jsx(VTMenu, __assign({ sx: __assign(__assign({ width: "30px", height: "30px", position: "absolute" }, (size > 115
                            ? { top: "5px", right: "5px" }
                            : { top: "2px", right: "2px" })), { zIndex: 2, "& .MuiButtonBase-root": {
                                background: "rgb(0, 0, 0, 0.6)",
                            } }), type: "icon", color: "secondary", onCloseFunction: function () {
                            setIsHovered(false);
                            setMenuOpen(false);
                        }, direction: "UP", offsetWidth: menuOffSet.width, offsetHeight: menuOffSet.height, menuOpen: menuOpen, setMenuOpen: function () { return setMenuOpen; }, onClick: function () { return setMenuOpen(!menuOpen); }, menuOptions: [
                            {
                                component: (_jsx(VTTextField, { placeholder: "Scene Name", value: localSceneName, endIcon: _jsx(_Fragment, { children: localSceneName !== name && (_jsxs(_Fragment, { children: [_jsx(CloseRounded, { onClick: function (e) {
                                                        setLocalSceneName(name);
                                                    }, sx: {
                                                        cursor: "pointer",
                                                    }, color: "error" }), _jsx(SaveRounded, { onClick: function (e) {
                                                        setSceneName(id, localSceneName);
                                                    }, sx: {
                                                        cursor: "pointer",
                                                        marginLeft: "5px",
                                                    }, color: "success" })] })) }), onChange: function (e) { return setLocalSceneName(e); }, sx: { marginInline: "5px" } })),
                            },
                            {
                                component: (_jsx(VTButton, __assign({ type: "list", startIcon: _jsx(ContentCopyRounded, {}), disabled: setSceneDuplicate === undefined, onClick: function () { return setSceneDuplicate(id); } }, { children: "Duplicate" }))),
                            },
                            {
                                component: (_jsxs(VTButton, __assign({ type: "list", startIcon: _jsx(DeleteRounded, {}), disabled: setSceneDelete === undefined, onClick: function () { return setSceneDelete(id); } }, { children: [" ", "Delete"] }))),
                            },
                            {
                                component: (_jsx(VTButton, __assign({ type: "list", startIcon: _jsx(VisibilityRounded, {}), disabled: setSceneInitialView === undefined, onClick: function () {
                                        setMenuOpen(false);
                                        setInitialViewDialog(true);
                                    } }, { children: "Set Initial View" }))),
                            },
                        ] }, { children: _jsx(MoreHorizIcon, { sx: { color: "white" } }) })), _jsxs(TimelineImageWrapper, __assign({ container: true, item: true, sx: {
                            background: active
                                ? "linear-gradient(to top left, #0ab5a7,#8e25fa)"
                                : "none",
                            padding: "4px",
                            width: size,
                            height: size * 0.75,
                        }, xs: 12, onMouseEnter: function () { return setIsHovered(true); }, onMouseLeave: function () { return setIsHovered(false); }, onClick: onClicked }, { children: [_jsx("img", { style: {
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    borderRadius: "15px",
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    padding: "4px",
                                    userSelect: "none",
                                    MozUserSelect: "none",
                                    WebkitUserSelect: "none",
                                }, src: previewImage
                                    ? previewImage
                                    : currentScene.mediaType === EMedia.IMAGE_360
                                        ? currentScene.src + "/f.jpg"
                                        : "https://cdn.naturettl.com/wp-content/uploads/2018/04/22005344/flowers-within-landscape-photography-3-1024x682.jpg" }), isHovered && (_jsxs(Box, __assign({ component: "div", sx: {
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    border: "linear-gradient(183deg, rgba(150,28,255,0.5) 0%, rgba(0,191,160,0.5) 100%)",
                                    height: "100%",
                                    width: "100%",
                                    background: "linear-gradient(183deg, rgba(150,28,255,0.5) 0%, rgba(0,191,160,0.5) 100%)",
                                    zIndex: 1,
                                    userSelect: "none",
                                } }, { children: [mediaType === EMedia.IMAGE_360 && (_jsx("img", { src: "/360-image.svg", style: getMediaTypeImageStyleObject(size) })), mediaType === EMedia.VIDEO_360 && (_jsx("img", { src: "/360-video.svg", style: getMediaTypeImageStyleObject(size) }))] })))] })), _jsx(Grid, __assign({ item: true, xs: 12, sx: {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginTop: "2px",
                            userSelect: "none",
                            MozUserSelect: "none",
                            WebkitUserSelect: "none",
                        } }, { children: name && (_jsx(Tooltip, __assign({ arrow: true, title: titleCutOffLimit && name.length >= titleCutOffLimit && name }, { children: _jsx(Typography, __assign({ variant: size > 135 ? "body1" : "caption" }, { children: titleCutOffLimit
                                    ? name && name.length <= titleCutOffLimit
                                        ? name
                                        : textCutOffAddElipsis(name, titleCutOffLimit)
                                    : name && name })) }))) }))] })), _jsx(VTLocation, { currentScene: currentScene, open: initialViewDialog, setOpen: function () {
                    setInitialViewDialog(!initialViewDialog);
                }, onSave: function (id, newPosition) {
                    setSceneInitialView(id, newPosition);
                } })] }));
}
